import React from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import './Layout.scss';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { pathname } = useLocation();

  return (
    <div className="layout-container">
      <div className="wrapper">
        <Sidebar />
        <section className="right-section">
          <div className="content-area">
            <div className="content-wrapper">
              {!pathname.startsWith('/settings') && <Header />}
              <main className="main-content">
                {children}
              </main>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Layout;
